export default __webpack_public_path__ + "static/media/img-8.9e9a3449.png";